<div class="buttons">
  <button
    class="button is-small is-info"
    translationEditableDirective="CREATE_BUILDING"
    (click)="onCreateBuilding()"
    *ngxPermissionsOnly="['CREATE_BUILDING']"
  >
    {{ 'CREATE_BUILDING' | translate }}
  </button>
</div>
<div class="digitization-wrapper">
  <map-coordinates-finder
    *ngIf="isCoordinatesPopupVisible"
    (onClose)="isCoordinatesPopupVisible = false"
    (onResultSelected)="highlightFeatureByCode($event)"
    [map]="map"
  ></map-coordinates-finder>
  <div id="ol-digitization" class="ol-map"></div>
  <div #olPopup class="ol-popup" [ngClass]="{ 'is-open': isPopupVisible }">
    <a href="#" class="ol-popup-closer"></a>
    <div class="ol-popup-content">
      <div *ngFor="let key of popupDataKeys">
        <div *ngIf="key !== 'prop_id' && key !== 'type'">
          <span [translationEditableDirective]="key | uppercase">{{
            key | uppercase | translate
          }}</span
          >:
          <span>{{ popupData[key] || '-' }}</span>
        </div>
      </div>
    </div>
  </div>
  <update-building-modal
    [feature]="selectedFeature"
    [geojson]="geojson"
    [isEditable]="editable"
    (close)="closeEdit()"
    (editableChange)="onEditableChange($event)"
    [isCreate]="isCreateOpen"
    (formChange)="formChange($event)"
    *ngIf="isEditOpen"
  ></update-building-modal>
</div>
